import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3e47156e")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_fa_icon = _resolveComponent("fa-icon")

  return (_openBlock(), _createBlock("div", {
    class: _ctx.buttonClass,
    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('click', $event)), ["self"]))
  }, [
    _createVNode(_component_fa_icon, {
      icon: _ctx.icon,
      onClick: _withModifiers(_ctx.onClickIcon, ["stop"])
    }, null, 8, ["icon", "onClick"])
  ], 2))
})